import type { MultiValue, SingleValue } from 'react-select';

/**
 * Type guard to determine if the provided value is a `MultiValue<T>` (an array)
 * rather than a `SingleValue<T>` (a single value or null) from `react-select`.
 *
 * @typeParam T - The type of the value(s) contained in the select component.
 * @param value - The value to check, which can be either a single value, null, or an array of values.
 * @returns `true` if the value is an array (`MultiValue<T>`), otherwise `false`.
 */
export const isMultiData = <T>(value: MultiValue<T> | SingleValue<T>): value is MultiValue<T> => {
  return Array.isArray(value);
};
